import(/* webpackMode: "eager" */ "/vercel/path0/app/pari/page.tsx");
